<template>
  <div id="usertable">
    <v-card
      class="mx-auto my-3"
      color="#e6e6fa"
    >
      <v-simple-table>
        <template v-slot:default class="user-table-inner">
          <thead>
            <tr>
              <th class="text-center" style="min-width:120px">プレイヤー</th>
              <th class="text-center" style="min-width:100px">役割</th>
              <th class="text-center" style="min-width:200px">陰謀カード</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(user, key) in users" v-bind:key="key">
              <td v-if="user.id==userId && user.isLeader && key%2==1" class="my-info odd" style="border-left:4px solid #ffa07a;"><span style="font-size:18px">★</span><b><u>{{ user.name }}</u></b></td>
              <td v-else-if="user.id==userId && key%2==1" class="my-info odd" style="border-left:4px solid #ffa07a;"><b><u>{{ user.name }}</u></b></td>
              <td v-else-if="user.isLeader && key%2==1" class="odd"><span style="font-size:18px">★</span>{{ user.name }}</td>
              <td v-else-if="key%2==1" class="odd">{{ user.name }}</td>
              <td v-else-if="user.id==userId && user.isLeader" class="my-info even" style="border-left:4px solid #ffa07a;"><span style="font-size:18px">★</span><b><u>{{ user.name }}</u></b></td>
              <td v-else-if="user.id==userId" class="my-info even" style="border-left:4px solid #ffa07a;"><b><u>{{ user.name }}</u></b></td>
              <td v-else-if="user.isLeader" class="even"><span style="font-size:18px">★</span>{{ user.name }}</td>
              <td v-else class="even">{{ user.name }}</td>

              <!-- <td v-if="user.isLeader && user.id==userId" class="my-info" style="color:black;font-size:24px">★</td>
              <td v-else-if="user.id==userId" class="my-info"></td>
              <td v-else-if="user.isLeader" style="color:black;font-size:24px">★</td>
              <td v-else></td> -->

              <td v-if="user.id==userId && user.role && user.role=='resistance' && key%2==1" class="my-info odd">
                <div class="role-resistance"><b>レジスタンス</b></div>
              </td>
              <td v-else-if="user.id==userId && user.role && user.role=='spy' && key%2==1" class="my-info odd">
                <div class="role-spy"><b>スパイ</b></div>
              </td>
              <td v-else-if="user.role && user.role=='resistance' && key%2==1" class="odd">
                <div class="role-resistance"><b>レジスタンス</b></div>
              </td>
              <td v-else-if="user.role && user.role=='spy' && key%2==1" class="odd">
                <div class="role-spy"><b>スパイ</b></div>
              </td>
              <td v-else-if="user.role && user.role=='unknown' && key%2==1" class="odd">
                <div class="role-unknown"><b>不明</b></div>
              </td>
              <td v-else-if="userId==user.id && key%2==1" class="my-info odd">-</td>
              <td v-else-if="key%2==1" class="odd">-</td>

              <td v-else-if="user.id==userId && user.role && user.role=='resistance'" class="my-info even">
                <div class="role-resistance"><b>レジスタンス</b></div>
              </td>
              <td v-else-if="user.id==userId && user.role && user.role=='spy'" class="my-info even">
                <div class="role-spy"><b>スパイ</b></div>
              </td>
              <td v-else-if="user.role && user.role=='resistance'" class="even">
                <div class="role-resistance"><b>レジスタンス</b></div>
              </td>
              <td v-else-if="user.role && user.role=='spy'" class="even">
                <div class="role-spy"><b>スパイ</b></div>
              </td>
              <td v-else-if="user.role && user.role=='unknown'" class="even">
                <div class="role-unknown"><b>不明</b></div>
              </td>
              <td v-else-if="userId==user.id" class="my-info even">-</td>
              <td v-else class="even">-</td>

              <td v-if="user.id==userId && user.plots.length>0 && key%2==1" class="my-info odd" style="border-right:4px solid #ffa07a;">
                <div v-for="(plot, plotKey) in user.plots" v-bind:key="plotKey">
                  <span v-if="plot.done" v-on:click="showPlotDescription(plot.id)" class="plotName"> <b>(済)<u><s>{{ getPlotName(plot.id) }}</s></u></b> </span>
                  <span v-else v-on:click="showPlotDescription(plot.id)" class="plotName"> <b><u>{{ getPlotName(plot.id) }}</u></b> </span>
                </div>
              </td>
              <td v-else-if="user.plots.length>0 && key%2==1" class="odd">
                <div v-for="(plot, plotKey) in user.plots" v-bind:key="plotKey">
                  <span v-if="plot.done" v-on:click="showPlotDescription(plot.id)" class="plotName"> <b>(済)<u><s>{{ getPlotName(plot.id) }}</s></u></b> </span>
                  <span v-else v-on:click="showPlotDescription(plot.id)" class="plotName"> <b><u>{{ getPlotName(plot.id) }}</u></b> </span>
                </div>
              </td>
              <td v-else-if="user.id==userId && key%2==1" class="my-info odd" style="border-right:4px solid #ffa07a;">-</td>
              <td v-else-if="key%2==1" class="odd">-</td>

              <td v-else-if="user.id==userId && user.plots.length>0" class="my-info even" style="border-right:4px solid #ffa07a;">
                <div v-for="(plot, plotKey) in user.plots" v-bind:key="plotKey">
                  <span v-if="plot.done" v-on:click="showPlotDescription(plot.id)" class="plotName"> <b>(済)<u><s>{{ getPlotName(plot.id) }}</s></u></b> </span>
                  <span v-else v-on:click="showPlotDescription(plot.id)" class="plotName"> <b><u>{{ getPlotName(plot.id) }}</u></b> </span>
                </div>
              </td>
              <td v-else-if="user.plots.length>0" class="even">
                <div v-for="(plot, plotKey) in user.plots" v-bind:key="plotKey">
                  <span v-if="plot.done" v-on:click="showPlotDescription(plot.id)" class="plotName"> <b>(済)<u><s>{{ getPlotName(plot.id) }}</s></u></b> </span>
                  <span v-else v-on:click="showPlotDescription(plot.id)" class="plotName"> <b><u>{{ getPlotName(plot.id) }}</u></b> </span>
                </div>
              </td>
              <td v-else-if="user.id==userId" class="my-info even" style="border-right:4px solid #ffa07a;">-</td>
              <td v-else class="even">-</td>

            </tr>
          </tbody>

        </template>
      </v-simple-table>
      <!-- <tr>
        <td>プレイヤー</td>
        <td>役割</td>
        <td>リーダー</td>
        <td>陰謀カード</td>
      </tr>

      <tr v-for="(value, key) in users" v-bind:key="key">
        <td>{{ value.name }}</td>
        <td v-if="value.role">
          {{ value.role }}
        </td>
        <td v-else>-</td>
        <td v-if="value.isLeader">o</td>
        <td v-else>-</td>
        <td v-if="value.plot">
          <span class="plotName" v-for="(plot, plotKey) in value.plot" v-bind:key="plotKey" v-on:click="doSomething(plot)"> {{ getPlotName(plot) }} </span>
        </td>
        <td v-else>-</td>

      </tr> -->

    </v-card>

  </div>
</template>

<script>
// import userTableRow from '@/components/userTableComponents/UserTableRow.vue'
export default {
  name: 'usertable',
  plops: ['showPlotEffect'],
  components: {

  },
  data(){
    return {
      // users: this.$store.state.userList.users
    }
  },
  computed: {
    userId: function() {
      return this.$store.getters.userId
    },
    users: function() {
      return this.$store.state.userList.users
    },
    getPlotName: function() {
      return (plotId) => this.$store.getters.getPlotName(plotId);
      // return this.$store.getters.getPlotName(plotId)
    }
  },
  methods: {
    showPlotDescription: function(plotId) {
      this.test = plotId
      var plotEffect = this.$store.getters.getPlotEffect(plotId);
      var modalContent = {title: plotEffect.name, text: plotEffect.effect}
      this.$emit('show-modal', modalContent)
    }
  }
}
</script>

<style>

#usertable th {
  font-size: 16px !important;
  border-bottom-width: 2px;
  border-color: black;
  color: white;
  background-color: #222288
}
#usertable td {
  font-size: 16px;
  border-bottom-width: 0px;
  border-color: black;
}

#usertable td.odd {
  background-color: #F5F5F5
}
#usertable td.even {
  background-color: #e6e6ea
}
#usertable .role-spy {
  background-color: #C02020;
  width: 120px;
  color: #FFFFFF;
  margin: auto;
}
#usertable .role-resistance {
  background-color: #6060E0;
  width: 120px;
  color: #FFFFFF;
  margin: auto;
}
#usertable .my-info {
  border-top:4px solid #ffa07a;
  border-bottom:4px solid #ffa07a;
}
#usertable .plotName {
  display: inline-block;
  margin-right: 4px;
  margin-left: 4px;
  color: #5555BB;
  cursor:pointer ;
}

</style>
